<template>
  <div style="width: 100%">
    <Card shadow style="width: 100%; height: 400px">
      <chart-bar style="width: 100%; height: 370px" :value="barData" />
    </Card>
    <Card shadow style="margin-top: 10px; width: 100%">
      <p slot="title" class="card-title">
        {{ $t("TransferOrder") + $t("overtime") + $t("statistics") }}
      </p>

      <Row
        v-if="overTimeData && overTimeData.length"
        :gutter="20"
        style="margin-top: 10px"
      >
        <Col
          v-for="(item, index) in overTimeData"
          :key="index"
          :span="4"
          style="margin-bottom: 20px"
        >
          <div @click="getOrderBtn(item)" class="home-card">
            <!-- @click="toPage(item)" -->
            <div class="card-item">
              <div>
                <span
                  class="card-item-dot"
                  :style="{ backgroundColor: item.color || '#19be6b' }"
                ></span>
                <span class="card-item-title">{{ item.warehouseTitle }}</span>
              </div>
              <div class="card-item-num">
                <count-to :end="item.total || 0"></count-to>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <p v-else class="card-con">{{ $t("NoData") }}~</p>
      <Modal
        v-model="orderModal"
        :width="600"
        :loading="loading"
        @on-cancel="cancelOrder"
        :footer-hide="true"
      >
        <p style="height: 33px" slot="header">
          <span style="margin-right: 20px">{{ orderModalData.title }}</span>
          <Button type="primary" @click="copyAllOrder">{{
            $t("all") + $t("copy")
          }}</Button>
        </p>
        <div style="max-height: 600px; overflow-y: auto">
          <Tag
            v-for="item in orderModalData.data"
            @click="copy(item)"
            type="dot"
            :key="item"
            :name="item"
            >{{ item }}
          </Tag>
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
import ChartBar from "./template/growthRate.vue";
import CountTo from "_c/count-to";
import {
  getCustomerServerBull,
  getCustomerServerOverTime,
  getTransferTimeOutAwb,
} from "@/api/performance/customerServerBull";
import { copyToClipboard } from "@/utils/copyClick";
// import format from "@/utils/format.js";
// import { getCountry } from "@/api/system/country";
// import { getChannel } from "@/api/tracker/channel";
// import { getAllClient } from "@/api/user/client";
// import { getAgent } from "@/api/tracker/agent";
// import { getSelectType } from "@/api/public";
// import { getUser } from "@/api/user/internal";
export default {
  name: "customerServerBull",
  components: {
    ChartBar,
    CountTo,
  },
  data() {
    return {
      barData: null,
      overTimeData: null,
      orderModal: false, //查看超时订单号
      //超时订单号
      orderModalData: {
        title: "",
        data: [],
      },
      loading: false,
    };
  },
  methods: {
    // toPage(item) {
    //   this.$router.push({ path: item.url, query: item.data || {} });
    // }
    customerServerBull() {
      getCustomerServerBull().then((res) => {
        this.barData = res.data.payload;
      });
    },
    // 获取转单超时
    customerServerOverTime() {
      getCustomerServerOverTime().then((res) => {
        this.overTimeData = res.data.payload;
      });
    },
    // 获取订单号
    getTransferTimeOutAwb(item) {
      this.loading = true;
      getTransferTimeOutAwb({
        warehouse_id: item.warehouse_id,
      }).then((res) => {
        this.orderModal = true;
        this.orderModalData.data = res.data.payload;
        this.orderModalData.title = item.warehouseTitle;
        this.loading = false;
      });
    },
    // 复制全部
    copyAllOrder() {
      copyToClipboard(this.orderModalData.data.join("\r\n"), this);
    },
    // 点击仓库
    getOrderBtn(data) {
      this.getTransferTimeOutAwb(data);
    },
    cancelOrder() {
      this.orderModal = false;
      this.orderModalData.data = [];
      // this.orderModalData.title = "";
    },
  },
  created() {
    this.customerServerBull();
    this.customerServerOverTime();
    // getCountry().then(res => {
    //   this.selData.countryList = res.data.payload.rows;
    // });
    // getChannel().then(res => {
    //   this.selData.transportList = res.data.payload.rows;
    // });
    // getAllClient().then(res => {
    //   this.selData.clientList = res.data.payload.rows;
    // });
    // getAgent({ types: "DELIVERY" }).then(res => {
    //   this.selData.deliveryList = res.data.payload.rows;
    // });
    // getSelectType(["OUTBOUND_SELECT_TYPE"]).then(res => {
    //   this.selData.headerList = res.data.payload["OUTBOUND_SELECT_TYPE"];
    // });
    // getSelectType(["DELIVERY_INTERVAL_SELECT_TYPE"]).then(res => {
    //   this.selData.typeList = res.data.payload["DELIVERY_INTERVAL_SELECT_TYPE"];
    // });
    // getSelectType(["ANALYZE_DATE_SELECT_TYPE"]).then(res => {
    //   this.selData.dateTypeList = res.data.payload["ANALYZE_DATE_SELECT_TYPE"];
    // });
    // getUser({ standard: "CustomerService" }).then(res => {
    //   this.selData.serviceList = res.data.payload.rows;
    // });
    // getUser({ standard: "DblCustomerService" }).then(res => {
    //   this.selData.dblSerList = res.data.payload.rows;
    // });
    // this.date = format.customTime(new Date(), "YYYY-MM");
  },
};
</script>

<style lang="less">
.count-style {
  font-size: 40px;
}
.ivu-card-head .card-title {
  color: #5b7497;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.ivu-card-body .card-con {
  color: #5b7497;
  text-align: center;
  font-size: 14px;
  height: 200px;
  line-height: 200px;
}
.home-card {
  background-color: #f5f7f9;
  border-radius: 2px;
  display: flex;

  .card-item {
    cursor: pointer;
    flex: 1;
    padding: 24px;
    text-align: center;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 20%;
      height: 60%;
      width: 1px;
      background-color: rgba(0, 0, 0, 0.09);
    }
    &:last-child {
      &::before {
        background-color: rgba(0, 0, 0, 0);
      }
    }
    .card-item-dot {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background-color: green;
      margin-right: 10px;
      vertical-align: middle;
    }
    .card-item-title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
    .card-item-num {
      margin-left: 16px;
      font-size: 34px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
